module.exports = __webpack_public_path__ + "img/LKW-Ladekran.e5d35008.svg";